export function convertToNumber(value) {
    if (typeof value === 'undefined' || value === null)
        return undefined;
    if (typeof value !== 'string')
        throw new Error(`Unable to convert value to number`);
    if (value === '')
        return null;
    if (isNaN(Number(value)))
        throw new Error(`QS value "${value}" cannot be represented as a 'number'.`);
    return Number(value);
}
